<template>
  <div
    v-if="visibleMenu"
    ref="collapsibleMenu"
    class="custom-menu"
    tabindex="0"
    @focusout="updateVisibleMenu(false)"
  >
    <ul>
      <template v-for="(item, index) in itemsMenu">
        <li v-if="item.visibility" :key="`${item}-${index}`">
          <div class="custom-menu__items" @click="handleRedirectToRoute(item)">
            <ion-icon :name="item.icon" />
            {{ item.label }}
          </div>
        </li>
      </template>
    </ul>
  </div>
</template>
<script>
import Vue from 'vue'
import redirectToLink from '@/common/mixins/redirectToLink.js'
import { mapMutations, mapState, mapGetters } from 'vuex'

export default Vue.extend({
  mixins: [redirectToLink],
  data() {
    return {
      showList: this.visibleMenu
    }
  },
  computed: {
    ...mapState(['visibleMenu']),
    ...mapGetters(['isNotificationSender', 'isBilling']),
    itemsMenu() {
      return [
        {
          visibility: true,
          label: 'Painel de Indicadores',
          icon: 'bar-chart-outline',
          route:
            process.env.VUE_APP_URL_OPERACAO_DASHBOARD ||
            'https://homologacao.app.clearsale.com.br/V2/Operacao/dashboard'
        },
        {
          visibility: true,
          label: 'Pesquisa de Pedidos ',
          icon: 'search-outline',
          route:
            process.env.VUE_APP_URL_OPERACAO_PESQUISA ||
            'https://homologacao.app.clearsale.com.br/v2/Operacao/pedidos/pesquisa'
        },
        {
          /* não funciona em HML, produto chargeBack não possui ambiente de HML */
          visibility: true,
          label: 'Chargeback',
          icon: 'wallet-outline',
          route:
            process.env.VUE_APP_URL_CHARGEBACK ||
            'https://cbk.clearsale.com.br/'
        },
        {
          visibility: this.isBilling,
          label: 'Financeiro ',
          icon: 'receipt-outline',
          route:
            process.env.VUE_APP_URL_FINANCEIRO ||
            'https://hmlfinanceiro.clear.sale/'
        },
        {
          visibility: this.isNotificationSender,
          label: 'Central de Notificações',
          icon: 'notifications-outline',
          route: '/central-notificacoes'
        },
        {
          visibility: true,
          label: 'Contato',
          icon: 'chatbox-outline',
          route:
            process.env.VUE_APP_URL_CONTATOS ||
            'https://academy-hml.clearsale.com.br/contato'
        }
      ]
    }
  },
  updated() {
    this.$refs.collapsibleMenu?.focus()
  },
  methods: {
    ...mapMutations({
      updateVisibleMenu: 'VISIBLE_MENU'
    }),
    handleRedirectToRoute({ isIntranet = false, route }) {
      this.updateVisibleMenu(false)
      if (isIntranet) return this.$router.push(route)
      this.redirectToLink(route)
    }
  },
  watch: {
    visibleMenu(visible) {
      this.showList = false

      if (visible) {
        setTimeout(() => {
          this.showList = true
        }, 400)
      }
    }
  }
})
</script>
<style lang="scss" scoped>
.custom-menu {
  background-color: $brand-primary-base;
  height: 100vh;
  display: flex;
  position: fixed;
  z-index: 4;
  padding: 1.5rem 0;
  outline: none;
  width: 21.5rem;

  animation: slideMenuAnimation 0.3s ease-in-out;

  @keyframes slideMenuAnimation {
    0% {
      transform: translateX(-21.5rem);
    }
    100% {
      transform: translateX(0);
    }
  }

  -webkit-transition: width 0.3s ease-in-out;
  -moz-transition: width 0.3s ease-in-out;
  -o-transition: width 0.3s ease-in-out;
  transition: width 0.3s ease-in-out;

  ul {
    padding-left: 24px;
    display: flex;
    flex-direction: column;
    justify-content: space-evenly;
    gap: 8px;
    height: fit-content;
  }

  li {
    font-family: 'Roboto';
    font-style: normal;
    margin-left: 88px;
    display: flex;
    justify-content: center;
    align-items: flex-start;
    color: $base-white;
    line-height: 1.5rem;
    font-size: 1rem;
    font-weight: 700;
    cursor: pointer;
    flex-direction: column;
    height: 48px;

    hr {
      width: 100%;
      height: 1px;
      opacity: 1;
      background: linear-gradient(
        90deg,
        rgba(239, 239, 239, 0) 0%,
        #e5e5e5 52.08%,
        rgba(239, 239, 239, 0) 100%
      );
    }

    .custom-menu__items {
      display: flex;
      align-items: center;

      ion-icon {
        width: 1.5rem;
        height: 1.5rem;
        margin-right: 0.5rem;
      }

      &:hover {
        color: $brand-secondary-base;

        ion-icon {
          color: $brand-secondary-base;
        }
      }
    }
  }
}
</style>
